var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-wrap"},[_c('div',{staticClass:"section-wrap-title"},[_c('span',{staticClass:"section-wrap-title-text"},[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"section-content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }